import React from 'react';
import ReactMarkdown from 'react-markdown';

import'./MarkdownContainer.css'

const MarkdownContainer = ({content , ...props}) =>  {
  return (
    <div className='text-gray-500 markdown-content'>
      <ReactMarkdown source={content} />
    </div>
  );
}

export default MarkdownContainer;